import { EnvironmentConfig } from '@abovo/shared-models';

export const environment: EnvironmentConfig = {
   production: true,
   appName: 'gerard',
   appType: 'app',
};
